<script>
    import Home from "../company/Home.svelte";
    import Entry from "../company/Entry.svelte";
    import Detail from "../company/Detail.svelte";

    let listCompany = [];
    let listPasaran = [];
    let record = "";
    let totalrecord = 0;
    let sData = "";
    let token = localStorage.getItem("token");
    let master = localStorage.getItem("master");
    let idcompany = "";
    let company_name_field = "";
    let master_company_id = "";
    let company_url_field = "";
    let company_angka_max_minbet_field = 0;
    let company_angka_max_minbasket_field = 0;
    let company_angka_max_maxbet_4d_field = 0;
    let company_angka_max_maxbet_3d_field = 0;
    let company_angka_max_maxbet_3dd_field = 0;
    let company_angka_max_maxbet_2d_field = 0;
    let company_angka_max_maxbet_2dd_field = 0;
    let company_angka_max_maxbet_2dt_field = 0;
    let company_angka_max_maxbet_4d_bbdisc_field = 0;
    let company_angka_max_maxbet_3d_bbdisc_field = 0;
    let company_angka_max_maxbet_3dd_bbdisc_field = 0;
    let company_angka_max_maxbet_2d_bbdisc_field = 0;
    let company_angka_max_maxbet_2dd_bbdisc_field = 0;
    let company_angka_max_maxbet_2dt_bbdisc_field = 0;
    let company_angka_max_win4d_full_field = 0;
    let company_angka_max_win3d_full_field = 0;
    let company_angka_max_win3dd_full_field = 0;
    let company_angka_max_win2d_full_field = 0;
    let company_angka_max_win2dd_full_field = 0;
    let company_angka_max_win2dt_full_field = 0;
    let company_angka_max_win4d_disc_field = 0;
    let company_angka_max_win3d_disc_field = 0;
    let company_angka_max_win3dd_disc_field = 0;
    let company_angka_max_win2d_disc_field = 0;
    let company_angka_max_win2dd_disc_field = 0;
    let company_angka_max_win2dt_disc_field = 0;
    let company_angka_max_win4d_bb_field = 0;
    let company_angka_max_win3d_bb_field = 0;
    let company_angka_max_win3dd_bb_field = 0;
    let company_angka_max_win2d_bb_field = 0;
    let company_angka_max_win2dd_bb_field = 0;
    let company_angka_max_win2dt_bb_field = 0;
    let company_angka_max_win4d_bbkena_field = 0;
    let company_angka_max_win3d_bbkena_field = 0;
    let company_angka_max_win3dd_bbkena_field = 0;
    let company_angka_max_win2d_bbkena_field = 0;
    let company_angka_max_win2dd_bbkena_field = 0;
    let company_angka_max_win2dt_bbkena_field = 0;
    let company_cbebas_max_minbet_field = 0;
    let company_cbebas_max_maxbet_field = 0;
    let company_cbebas_max_win_field = 0;
    let company_cmacau_max_minbet_field = 0;
    let company_cmacau_max_maxbet_field = 0;
    let company_cmacau_max_win2_field = 0;
    let company_cmacau_max_win3_field = 0;
    let company_cmacau_max_win4_field = 0;
    let company_cnaga_max_minbet_field = 0;
    let company_cnaga_max_maxbet_field = 0;
    let company_cnaga_max_win3_field = 0;
    let company_cnaga_max_win4_field = 0;
    let company_cjitu_max_minbet_field = 0;
    let company_cjitu_max_maxbet_field = 0;
    let company_cjitu_max_winas_field = 0;
    let company_cjitu_max_winekor_field = 0;
    let company_cjitu_max_winkepala_field = 0;
    let company_cjitu_max_winkop_field = 0;
    let company_umum50_max_minbet_field = 0;
    let company_umum50_max_maxbet_field = 0;
    let company_special50_max_minbet_field = 0;
    let company_special50_max_maxbet_field = 0;
    let company_kombinasi50_max_minbet_field = 0;
    let company_kombinasi50_max_maxbet_field = 0;
    let company_macau_max_minbet_field = 0;
    let company_macau_max_maxbet_field = 0;
    let company_macau_max_win_field = 0;
    let company_dasar_max_minbet_field = 0;
    let company_dasar_max_maxbet_field = 0;
    let company_shio_max_minbet_field = 0;
    let company_shio_max_maxbet_field = 0;
    let company_shio_max_win_field = 0;
    let company_shio_parent_field = "0";

    let company_status_field = "";
    let company_create_field = "";
    let company_update_field = "";
    const handleRefreshData = (e) => {
        listCompany = [];
        totalrecord = 0;
        setTimeout(function () {
            initCompany();
        }, 1000);
    };
    const handleBackHalaman = () => {
        idcompany = "";
        sData = "";
        listCompany = [];
        handleRefreshData("all");
    };
    const handleEditData = (e) => {
        idcompany = e.detail.e;
        sData = "Edit";
        editCompany(idcompany);
    };
    const handleDetailData = (e) => {
        idcompany = e.detail.e;
        sData = "Detail";
        initPasaran(idcompany);
    };
    async function initapp() {
        const res = await fetch("/api/init", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                master: master,
                page: "COMPANY_HOME",
            }),
        });
        const json = await res.json();
        if (json.status === 400) {
            logout();
        } else {
            // setTimeout(function(){ initPasaran() }, 1000);
            initCompany();
        }
    }
    async function initCompany() {
        const res = await fetch("/api/company", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                company_search: "",
            }),
        });
        const json = await res.json();
        if (json.status == 200) {
            record = json.record;
            totalrecord = record.length;
            if (record != null) {
                for (var i = 0; i < record.length; i++) {
                    let css_winlose = "color:red;font-weight:bold;";
                    let css_winlose_temp = "color:red;font-weight:bold;";
                    let css_winlose_selisih = "color:red;font-weight:bold;";
                    let selisihwinlose = parseInt(record[i]["company_winlosetemp"]) - parseInt(record[i]["company_winlose"])
                    if(parseInt(record[i]["company_winlose"]) > 0){
                        css_winlose = "color:blue;font-weight:bold;";
                    }else{
                        css_winlose = "color:red;font-weight:bold;";
                    }
                    if(parseInt(record[i]["company_winlosetemp"]) > 0){
                        css_winlose_temp = "color:blue;font-weight:bold;";
                    }else{
                        css_winlose_temp = "color:red;font-weight:bold;";
                    }
                    if(selisihwinlose){
                        css_winlose_selisih = "color:blue;font-weight:bold;";
                    }
                    listCompany = [
                        ...listCompany,
                        {
                            no: record[i]["company_no"],
                            company_idcompany: record[i]["company_idcompany"],
                            company_startjoin: record[i]["company_startjoin"],
                            company_endjoin: record[i]["company_endjoin"],
                            company_curr: record[i]["company_curr"],
                            company_name: record[i]["company_name"],
                            company_owner: record[i]["company_owner"],
                            company_phone: record[i]["company_phone"],
                            company_email: record[i]["company_email"],
                            company_periode: record[i]["company_periode"],
                            company_winlose: record[i]["company_winlose"],
                            company_winlosetemp: record[i]["company_winlosetemp"],
                            company_winlosecss: css_winlose,
                            company_winlosetempcss: css_winlose_temp,
                            company_selisihwinlose: selisihwinlose,
                            company_selisihwinlosecss: css_winlose_selisih,
                            company_status: record[i]["company_status"],
                            company_statuscss: record[i]["company_statuscss"],
                        },
                    ];
                }
            } else {
                alert("Error");
            }
        } else {
            // logout();
        }
    }
    async function editCompany(e) {
        const res = await fetch("/api/companydetail", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                company: e,
                page: "COMPANY_SAVE",
                master: master,
                sData: "Edit",
            }),
        });
        const json = await res.json();
        let record = json.record;
        if (json.status === 400) {
            logout();
        } else {
            for (let i = 0; i < record.length; i++) {
                company_name_field = record[i]["company_name"];
                master_company_id = record[i]["company_master"]
                company_url_field = record[i]["company_url"];
                company_angka_max_minbet_field = record[i]["company_angka_max_minbet"];
                company_angka_max_minbasket_field = record[i]["company_angka_max_minbasket"];
                company_angka_max_maxbet_4d_field = record[i]["company_angka_max_maxbet_4d"];
                company_angka_max_maxbet_3d_field = record[i]["company_angka_max_maxbet_3d"];
                company_angka_max_maxbet_3dd_field = record[i]["company_angka_max_maxbet_3dd"];
                company_angka_max_maxbet_2d_field = record[i]["company_angka_max_maxbet_2d"];
                company_angka_max_maxbet_2dd_field = record[i]["company_angka_max_maxbet_2dd"];
                company_angka_max_maxbet_2dt_field = record[i]["company_angka_max_maxbet_2dt"];
                company_angka_max_maxbet_4d_bbdisc_field = record[i]["company_angka_max_maxbet_4d_bbdisc"];
                company_angka_max_maxbet_3d_bbdisc_field = record[i]["company_angka_max_maxbet_3d_bbdisc"];
                company_angka_max_maxbet_3dd_bbdisc_field = record[i]["company_angka_max_maxbet_3dd_bbdisc"];
                company_angka_max_maxbet_2d_bbdisc_field = record[i]["company_angka_max_maxbet_2d_bbdisc"];
                company_angka_max_maxbet_2dd_bbdisc_field = record[i]["company_angka_max_maxbet_2dd_bbdisc"];
                company_angka_max_maxbet_2dt_bbdisc_field = record[i]["company_angka_max_maxbet_2dt_bbdisc"];
                company_angka_max_win4d_full_field = record[i]["company_angka_max_win4d_full"];
                company_angka_max_win3d_full_field = record[i]["company_angka_max_win3d_full"];
                company_angka_max_win3dd_full_field = record[i]["company_angka_max_win3dd_full"];
                company_angka_max_win2d_full_field = record[i]["company_angka_max_win2d_full"];
                company_angka_max_win2dd_full_field = record[i]["company_angka_max_win2dd_full"];
                company_angka_max_win2dt_full_field = record[i]["company_angka_max_win2dt_full"];
                company_angka_max_win4d_disc_field = record[i]["company_angka_max_win4d_disc"];
                company_angka_max_win3d_disc_field = record[i]["company_angka_max_win3d_disc"];
                company_angka_max_win3dd_disc_field = record[i]["company_angka_max_win3dd_disc"];
                company_angka_max_win2d_disc_field = record[i]["company_angka_max_win2d_disc"];
                company_angka_max_win2dd_disc_field = record[i]["company_angka_max_win2dd_disc"];
                company_angka_max_win2dt_disc_field = record[i]["company_angka_max_win2dt_disc"];
                company_angka_max_win4d_bb_field = record[i]["company_angka_max_win4d_bb"];
                company_angka_max_win3d_bb_field = record[i]["company_angka_max_win3d_bb"];
                company_angka_max_win3dd_bb_field = record[i]["company_angka_max_win3dd_bb"];
                company_angka_max_win2d_bb_field = record[i]["company_angka_max_win2d_bb"];
                company_angka_max_win2dd_bb_field = record[i]["company_angka_max_win2dd_bb"];
                company_angka_max_win2dt_bb_field = record[i]["company_angka_max_win2dt_bb"];
                company_angka_max_win4d_bbkena_field = record[i]["company_angka_max_win4d_bb_kena"];
                company_angka_max_win3d_bbkena_field = record[i]["company_angka_max_win3d_bb_kena"];
                company_angka_max_win3dd_bbkena_field = record[i]["company_angka_max_win3dd_bb_kena"];
                company_angka_max_win2d_bbkena_field = record[i]["company_angka_max_win2d_bb_kena"];
                company_angka_max_win2dd_bbkena_field = record[i]["company_angka_max_win2dd_bb_kena"];
                company_angka_max_win2dt_bbkena_field = record[i]["company_angka_max_win2dt_bb_kena"];
                company_cbebas_max_minbet_field = record[i]["company_cbebas_max_minbet"];
                company_cbebas_max_maxbet_field = record[i]["company_cbebas_max_maxbet"];
                company_cbebas_max_win_field = record[i]["company_cbebas_max_win"].toFixed(2);
                company_cmacau_max_minbet_field = record[i]["company_cmacau_max_minbet"];
                company_cmacau_max_maxbet_field = record[i]["company_cmacau_max_maxbet"];
                company_cmacau_max_win2_field = record[i]["company_cmacau_max_win2"].toFixed(2);
                company_cmacau_max_win3_field = record[i]["company_cmacau_max_win3"].toFixed(2);
                company_cmacau_max_win4_field = record[i]["company_cmacau_max_win4"].toFixed(2);
                company_cnaga_max_minbet_field = record[i]["company_cnaga_max_minbet"];
                company_cnaga_max_maxbet_field = record[i]["company_cnaga_max_maxbet"];
                company_cnaga_max_win3_field = record[i]["company_cnaga_max_win3"].toFixed(2);
                company_cnaga_max_win4_field = record[i]["company_cnaga_max_win4"].toFixed(2);
                company_cjitu_max_minbet_field = record[i]["company_cjitu_max_minbet"];
                company_cjitu_max_maxbet_field = record[i]["company_cjitu_max_maxbet"];
                company_cjitu_max_winas_field = record[i]["company_cjitu_max_winas"].toFixed(2);
                company_cjitu_max_winekor_field = record[i]["company_cjitu_max_winekor"].toFixed(2);
                company_cjitu_max_winkepala_field = record[i]["company_cjitu_max_winkepala"].toFixed(2);
                company_cjitu_max_winkop_field = record[i]["company_cjitu_max_winkop"].toFixed(2);
                company_umum50_max_minbet_field = record[i]["company_umum50_max_minbet"];
                company_umum50_max_maxbet_field = record[i]["company_umum50_max_maxbet"];
                company_special50_max_minbet_field = record[i]["company_special50_max_minbet"];
                company_special50_max_maxbet_field = record[i]["company_special50_max_maxbet"];
                company_kombinasi50_max_minbet_field = record[i]["company_kombinasi50_max_minbet"];
                company_kombinasi50_max_maxbet_field = record[i]["company_kombinasi50_max_maxbet"];
                company_macau_max_minbet_field = record[i]["company_macau_max_minbet"];
                company_macau_max_maxbet_field = record[i]["company_macau_max_maxbet"];
                company_macau_max_win_field = record[i]["company_macau_max_win"].toFixed(2);
                company_dasar_max_minbet_field = record[i]["company_dasar_max_minbet"];
                company_dasar_max_maxbet_field = record[i]["company_dasar_max_maxbet"];
                company_shio_max_minbet_field = record[i]["company_shio_max_minbet"];
                company_shio_max_maxbet_field = record[i]["company_shio_max_maxbet"];
                company_shio_max_win_field = record[i]["company_shio_max_win"].toFixed(2);
                company_shio_parent_field = String(record[i]["company_shio_parent"]);
                company_status_field = record[i]["company_status"];
                company_create_field = record[i]["company_create"];
                company_update_field = record[i]["company_update"];
            }
        }
    }
    async function initPasaran(e) {
        listPasaran = []
        const res = await fetch("/api/companylistpasaran", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
                company: e,
                master: master,
                page: "COMPANY_HOME",
                sdata: "New",
            }),
        });
        const json = await res.json();
        let record = json.record;
        if (json.status == 200) {
            record = json.record;
            if (record != null) {
                let nmpasaran = ""
                for (var i = 0; i < record.length; i++) {
                    nmpasaran = record[i]["company_pasaran_nmpasarantogel"];
                    if(record[i]["company_pasaran_aliasnmpasarantogel"] != ""){
                        nmpasaran = record[i]["company_pasaran_aliasnmpasarantogel"]
                    }
                    listPasaran = [
                        ...listPasaran,
                        {
                            company_idcomppasaran: record[i]["company_pasaran_idcomppasaran"],
                            company_nmpasarantogel: nmpasaran,
                        },
                    ];
                }
            } else {
                alert("Error");
            }
        } else {
            logout();
        }
    }
    async function logout() {
        localStorage.clear();
        window.location.href = "/";
    }
    initapp();
</script>

{#if sData == "" && idcompany == ""}
    <Home
        on:handleRefreshData={handleRefreshData}
        on:handleEditData={handleEditData}
        on:handleDetailData={handleDetailData}
        {totalrecord}
        {listCompany}
        {master}
        {token}
    />
{:else}
    {#if sData == "Edit" }
        <Entry
            on:handleBackHalaman={handleBackHalaman}
            {sData}
            {master}
            {token}
            {idcompany}
            {master_company_id}
            {company_name_field}
            {company_url_field}
            {company_angka_max_minbet_field}
            {company_angka_max_minbasket_field}
            {company_angka_max_maxbet_4d_field}
            {company_angka_max_maxbet_3d_field}
            {company_angka_max_maxbet_3dd_field}
            {company_angka_max_maxbet_2d_field}
            {company_angka_max_maxbet_2dd_field}
            {company_angka_max_maxbet_2dt_field}
            {company_angka_max_maxbet_4d_bbdisc_field}
            {company_angka_max_maxbet_3d_bbdisc_field}
            {company_angka_max_maxbet_3dd_bbdisc_field}
            {company_angka_max_maxbet_2d_bbdisc_field}
            {company_angka_max_maxbet_2dd_bbdisc_field}
            {company_angka_max_maxbet_2dt_bbdisc_field}
            {company_angka_max_win4d_full_field}
            {company_angka_max_win3d_full_field}
            {company_angka_max_win3dd_full_field}
            {company_angka_max_win2d_full_field}
            {company_angka_max_win2dd_full_field}
            {company_angka_max_win2dt_full_field}
            {company_angka_max_win4d_disc_field}
            {company_angka_max_win3d_disc_field}
            {company_angka_max_win3dd_disc_field}
            {company_angka_max_win2d_disc_field}
            {company_angka_max_win2dd_disc_field}
            {company_angka_max_win2dt_disc_field}
            {company_angka_max_win4d_bb_field}
            {company_angka_max_win3d_bb_field}
            {company_angka_max_win3dd_bb_field}
            {company_angka_max_win2d_bb_field}
            {company_angka_max_win2dd_bb_field}
            {company_angka_max_win2dt_bb_field}
            {company_angka_max_win4d_bbkena_field}
            {company_angka_max_win3d_bbkena_field}
            {company_angka_max_win3dd_bbkena_field}
            {company_angka_max_win2d_bbkena_field}
            {company_angka_max_win2dd_bbkena_field}
            {company_angka_max_win2dt_bbkena_field}
            {company_cbebas_max_minbet_field}
            {company_cbebas_max_maxbet_field}
            {company_cbebas_max_win_field}
            {company_cmacau_max_minbet_field}
            {company_cmacau_max_maxbet_field}
            {company_cmacau_max_win4_field}
            {company_cmacau_max_win3_field}
            {company_cmacau_max_win2_field}
            {company_cnaga_max_minbet_field}
            {company_cnaga_max_maxbet_field}
            {company_cnaga_max_win4_field}
            {company_cnaga_max_win3_field}
            {company_cjitu_max_minbet_field}
            {company_cjitu_max_maxbet_field}
            {company_cjitu_max_winas_field}
            {company_cjitu_max_winekor_field}
            {company_cjitu_max_winkepala_field}
            {company_cjitu_max_winkop_field}
            {company_umum50_max_minbet_field}
            {company_umum50_max_maxbet_field}
            {company_special50_max_minbet_field}
            {company_special50_max_maxbet_field}
            {company_kombinasi50_max_minbet_field}
            {company_kombinasi50_max_maxbet_field}
            {company_macau_max_minbet_field}
            {company_macau_max_maxbet_field}
            {company_macau_max_win_field}
            {company_dasar_max_minbet_field}
            {company_dasar_max_maxbet_field}
            {company_shio_max_minbet_field}
            {company_shio_max_maxbet_field}
            {company_shio_max_win_field}
            {company_shio_parent_field}
            {company_status_field}
            {company_create_field}
            {company_update_field}
        />
    {:else}
        <Detail
            on:handleBackHalaman={handleBackHalaman}
            {sData}
            {master}
            {token}
            {idcompany}
            {listPasaran}
        />
    {/if}
{/if}
